import { PanelSection, PanelTab } from '../SidePanel';
import Shortcut from '../basics/Shortcut';
import { SHORTCUTS } from '../../constants/shortcuts';
import PopOutTab from './PopOutTab';
import {
  rightMenuTabs,
  useRightMenuTabContext,
} from '../../contexts/RightMenuTabContext';

type RightMenuTabProps = {
  activeTab: string;
  popOutEnabled?: boolean;
  setActiveTab: (activeTab: string) => void;
  tabs?: string[];
};

const defaultTabs = Object.values(rightMenuTabs);

const RightMenuTabs = ({
  activeTab,
  popOutEnabled = false,
  setActiveTab,
  tabs = defaultTabs,
}: RightMenuTabProps) => {
  const { popOutTabOpen } = useRightMenuTabContext();
  return (
    <PanelSection>
      <ul className="d-flex">
        {tabs.map((tab, i) => {
          // Render the pop out button for last tab if pop out enabled
          const renderPopOut = popOutEnabled && i === tabs.length - 1;
          return (
            <li key={tab}>
              <PanelTab
                role="button"
                isActive={activeTab === tab}
                onClick={() => setActiveTab(tab)}
              >
                {renderPopOut ? <PopOutTab>{tab}</PopOutTab> : tab}
              </PanelTab>
            </li>
          );
        })}
      </ul>
      <Shortcut
        shortcut={SHORTCUTS.TOGGLE_RIGHT_MENU_TABS.key}
        handler={() => {
          const activeTabIndex = tabs.indexOf(activeTab) ?? -1;
          const tabsCount = tabs.length - (popOutTabOpen ? 1 : 0);
          const nextTab = tabs[(activeTabIndex + 1) % tabsCount];
          setActiveTab(nextTab);
        }}
      />
    </PanelSection>
  );
};

export default RightMenuTabs;
